const extractVueFunctions = function() {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_c('QuickNav')],1),_vm._v(" "),_c('p',[_c('SearchFull')],1)])}
var staticRenderFns = []

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"title":"Search","showInSitemap":true,"summary":"Site search","createdAt":"2010-02-14","showToc":false},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }